import { palette } from '@client/theme/colors';
import { radii, theme } from '../constants';
import type { ThemeOptions } from '@mui/material';

const Accordion: ThemeOptions['components'] = {
  MuiAccordion: {
    styleOverrides: {
      rounded: {
        borderColor: palette.grey[300],
        borderRadius: radii.small,
        borderStyle: 'solid',
        borderWidth: 1,
      },
    },
  },
  MuiAccordionActions: {
    styleOverrides: {
      root: {
        backgroundColor: palette.divider,
      },
    },
  },
  MuiAccordionDetails: {
    styleOverrides: {
      root: {
        borderTopColor: palette.grey[300],
        borderTopStyle: 'solid',
        borderTopWidth: 1,
        padding: theme.spacing(1.5),
      },
    },
  },
  MuiAccordionSummary: {
    styleOverrides: {
      root: {
        margin: 0,
        padding: theme.spacing(0, 1.5),

        '&.Mui-expanded': {
          margin: 0,
          minHeight: 'auto',
        },
      },
      gutters: {
        padding: theme.spacing(0, 1.5),
      },
      content: {
        margin: theme.spacing(1.5, 0),

        '&.Mui-expanded': {
          margin: theme.spacing(1.5, 0),
        },
      },
    },
  },
};

export default Accordion;
